<div id="home" class="surface-0 overflow-hidden">
  <div
    class="py-4 px-4 mx-0 md:mx-6 lg:mx-8 lg:px-8 header-container "
  >
    <a class="flex align-items-center" href="#">
      <img
        src="assets/activitiesImages/micada_new_logo.png"
        alt="Micada Logo"
        height="50"
        class="mr-0 ml-4 lg:mr-2"
      /><span class="text-900 font-medium text-2xl line-height-3 mr-8"></span>
    </a>
    <div
      class="align-items-center surface-0 flex-grow-1 justify-content-end lg:flex lg:static w-full left-0 px-6 lg:px-0 z-2"
      style="top: 92%"
    >
      <!-- <ul
        class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row cursor-pointer"
      >
        <li>
          <a
            pRipple
            class="flex m-0 md:ml-5 px-0 py-3 text-900 font-medium line-height-3"
          >
            <span>Home</span>
          </a>
        </li>
        <li>
          <a
            pRipple
            class="flex m-0 md:ml-5 px-0 py-3 text-900 font-medium line-height-3"
          >
            <span>Tenders</span>
          </a>
        </li>
        <li>
          <a
            pRipple
            class="flex m-0 md:ml-5 px-0 py-3 text-900 font-medium line-height-3"
          >
            <span>Information System</span>
          </a>
        </li>
      </ul> -->
      <div
        class="flex justify-content-end lg:block border-top-1 lg:border-top-none surface-border py-3 lg:py-0 mt-3 lg:mt-0"
      >
        <!-- <button pButton pRipple label="Login" class="p-button-text p-button-rounded border-none font-light line-height-2 text-blue-500"  (click)="menu.toggle($event)" ></button>
              <p-menu #menu [popup]="true" [model]="items"></p-menu>
              <button pButton pRipple label="Register" class="p-button-rounded border-none ml-5 font-light line-height-2 bg-blue-500 text-white"></button> -->

        <a [routerLink]="['/phone-login']">
          <button
            pButton
            pRipple
            label="Farmer Login"
            class="p-button-text p-button-rounded border-none font-light line-height-2 text-blue-500"
          ></button>
        </a>
        <a [routerLink]="['/login']">
          <button
            pButton
            pRipple
            label="Login"
            class="p-button-rounded border-none ml-5 font-light line-height-2 bg-blue-500 text-white"
          ></button>
        </a>
      </div>
    </div>
  </div>

  <div id="hero" class=" card grid py-4 px-4 relative">
    <div class="col-9">
      <img
                  style="max-width: 100% ; max-height: 100%"
                  src="assets/home/upload_3.jpg"
                  [alt]="'product'"
                  class="product-image"
                />
      <!-- <p-carousel
        [value]="images"
        [numVisible]="1"
        [numScroll]="1"
        [circular]="true"
        [autoplayInterval]="3000"
        [responsiveOptions]="responsiveOptions"
      >
        <ng-template let-product pTemplate="item">
          <div class="product-item">
            <div class="product-item-content" >
                <img
                  style="max-width: 100% ; max-height: 100%"
                  src="assets/home/upload_{{ product }}.jpg"
                  [alt]="product"
                  class="product-image"
                />
            </div>
          </div>
        </ng-template>
      </p-carousel> -->
    </div>
    <div class="card col-3">
      <div class="header">NEWS & EVENTS</div>
      <div class="scroll p-4">
        <marquee direction="up">
          <p style="color: #a91e22">FARMER ONLINE APPLICATION FOR MI</p>
          <p>
            FARMER ONLINE APPLICATION has been inaugurated by Hon'ble Chief
            Minister Haryana on dated 16/01/2021
          </p>
          <p style="color: #a91e22">CADA Administrator</p>
          <p>
            Sh. Birender Singh, EIC, Administrator CADA Haryana Panchkula
          </p>
          <p style="color: #a91e22">CADA Chief Engineer</p>
          <p>Sh. Suresh Yadav, Chief Engineer, CADA Haryana Panchkula</p>
        </marquee>
      </div>
    </div>
  </div>

  <div id="features" class="grid py-4 px-4 mt-5 mx-0">
    <!-- <div class="row justify-content-center"> -->
    <div class="col-3 section-quick-link text-center">
      <div class="quick-links">QUICK LINKS</div>
      <div class="links-container">
        <div class="links">
          <a
            class="AG"
            href="assets/home/Appointment Regarding Document.pdf"
            target="_blank"
            >Advertisement date 29/06/2021- for the Post of Director
            (Communication), Director (Agronomy) and Deputy Director
            (Agronomy).<br />
            <img src="assets/home/newitem.gif"
          /></a>
        </div>
        <div class="links">
          <a class="AG" href="assets/home/waterpolicy2122.pdf" target="_blank">
            <img src="assets/home/newitem.gif" />
            <h3 style="color: maroon">Water Policy 2021</h3>
          </a>
        </div>
        <div class="links">
          <a [routerLink]="['/phone-login']"
            class="AG"

            >Farmer Online Application Web Portal for Micro Irrigation<br />
            <img src="assets/home/newitem.gif"
          /></a>
        </div>
        <!-- <div class="links">
          <a
            class="AG"
            href="#"
            id="a_tag_id"
            target="_blank"
            >अटल भूजल क्षेत्रिया अधिकारी लॉग इन करें
            <br />
            <img src="assets/home/newitem.gif"
          /></a>
        </div> -->

        <div class="links">
          <a class="AG" target="_blank"
            >MICADA PORTAL से सम्बंधित योजनाओ की जानकारी हेतु आप हेल्पलाइन
            संख्या 0172-2583940 पर 9.00 AM to 5.00 PM संपर्क कर सकते है
            <img src="assets/home/newitem.gif"
          /></a>
        </div>

        <!-- <div class="links">
          <a class="AG" href="#" target="_blank"
            >Vendor Login
            <br />
            <img src="assets/home/newitem.gif"
          /></a>
        </div> -->
        <div class="links">
          <a
            class="AG"
            href="assets/home/On Farm Water Tank Policy Final- 2020-21.pdf"
            target="_blank"
          >
            <img src="assets/home/newitem.gif" />
            <h3 style="color: maroon">
              On Farm Water Tank Policy Final- 2020-21
            </h3>
          </a>
        </div>
        <div class="links">
          <a href="assets/home/Guidelines MI.pdf" class="AG" target="_blank"
            >Implementation Guidelines (Micro Irrigation: 2021-22)
            <img src="assets/home/newitem.gif"
          /></a>
        </div>
        <div class="links">
          <a href="#" class="AG" target="_blank"
            >MI circular for the year 2021-22<img src="assets/home/newitem.gif"
          /></a>
        </div>
        <div class="links">
          <a href="assets/home/AarogyaSetuIVRS.pdf" class="AG" target="_blank"
            >Aarogya Setu IVRS - Call 1921</a
          >
        </div>

        <div class="image_gal">
          <a href="Album.aspx" onclick="openimagegalary(1)" class="english"
            >Image gallery</a
          >
        </div>
        <div class="video_gal">
          <a onclick="openvideogalary(1)" class="english">Video gallery</a>
        </div>
        <div class="links">
          <a
            >FAQ (लगातार पूछे जाने वाले प्रश्न)<img
              src="assets/home/newitem.gif"
          /></a>
        </div>

        <div
          style="border: 2px solid red; padding: 10px; border-radius: 50px 20px"
        >
          <ul>
            <li>
              <a href="FAQ1.pdf" target="_blank"
                >ड्रिप इरिगेशन के फायदों पर प्रश्न</a
              >
            </li>
            <li>
              <a href="FAQ2.pdf" target="_blank"
                >सूक्ष्म सिंचाई योजनाए और उनसे किसानो को होने वाले लाभ</a
              >
            </li>
            <li>
              <a href="FAQ3.pdf" target="_blank"
                >एकीकृत MICADA पोर्टल से संबंधित प्रश्न</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-6 section-content">
      <div class="welcome_div">
        <h1>
          Welcome to Micro Irrigation &amp; Command Area Development Authority
        </h1>
        <span>About CADA, Haryana </span>
        <p></p>
        <p>
          &nbsp;Command Area Development Authority was set up in Haryana in the
          year 1974 under a Centrally Sponsored Scheme on sharing basis i.e.
          50:50 by the State Government and Government of India to bridge the
          gap between the irrigation potential created and irrigation potential
          utilized through micro level infrastructure development and effective
          farm water management, to enhance agricultural production &amp;
          productivity and to improve socio-economic conditions of the farmers
          on selected Canal Commands in the state under Command Area Development
          Programme (CADP).
        </p>
        <p>
          The CAD programme was restructured and renamed as Command Area
          Development &amp; Water Management (CADWM) w.e.f. 01.04.2004 and since
          2008-09 the programme was implemented as a State sector scheme with
          Central assistance up-to 2015-16. <br />As per the latest guidelines
          issued in December, 2016 by the Government of India, Ministry of Water
          Resources, River Development and Ganga Rejuvenation, New Delhi, the
          Command Area Development &amp; Water Management (CAD&amp;WM) works
          shall be covered by the GoI under Incentivization Scheme for Bridging
          Irrigation Gap (ISBIG) under the umbrella scheme of “Pradhan Mantri
          Krishi Sinchayee Yojana” (PMKSY) “Har Khet Ko Pani” component.
        </p>
        <p><b>ORGANISATIONAL SETUP</b></p>
        <p>
          The overall control of CADA Haryana vests with its State Level
          Monitoring Committee cum Governing Body headed by the Chairman who is
          the Administrative Secretary to Government of Haryana, Irrigation
          &amp; Water Resources Department with following members:-<br />1.
          Administrative Secretary, Irrigation Department Chairman <br />2.
          Administrator, CADA, Haryana, Member Secy. <br />3. Senior Joint
          Commissioner (CADWM) GoI or his representative Member <br />4. Vice
          Chancellor, CCS, Haryana or his representative Member<br />5.
          Director, Agriculture, Haryana or his representative Member<br />6.
          Engineer-in-Chief, Irrigation Department Haryana Member<br />7.
          Secretary, Finance, Haryana or his representative Member<br />8.
          Principal Director, HIRMI, Kurukshetra Member<br />9. Chief Engineer,
          CADA, Haryana Member <br />10. Officer on Special Duty, CADA, Haryana
          Member<br />11. Representative of Central Water Commission Member
          <br />12. Representative of Central Ground Water Board Member<br />13.
          Director of Central Soil Salinity Research Institute Karnal Member or
          his representative <br />14. Representative Water Users Association
          Member
        </p>
        <p>&nbsp;</p>
        <p></p>
      </div>

      <!-- <div class="page-links">
        <a href="#" class="blue"
          ><i><img src="upload/M_1-9-2015-11-59-27.png" alt="" /></i
          ><span>Tenders</span></a
        >
        <a href="#" class="blue par"
          ><i><img src="upload/M_1-9-2015-12-1-4.png" alt="" /></i
          ><span>Evaluation Study</span></a
        >

        <a href="Page.aspx?PID=167&amp;LanguageType=1" class="blue org"
          ><i><img src="upload/M_1-9-2015-10-37-36.png" alt="" /></i
          ><span>Projects</span></a
        >

        <a href="Page.aspx?PID=168&amp;LanguageType=1" class="blue green"
          ><i><img src="upload/M_1-9-2015-10-58-17.png" alt="" /></i
          ><span>Annual Plan</span></a
        >

        <a href="Page.aspx?PID=1183&amp;LanguageType=1" class="blue gray"
          ><i><img src="upload/" alt="" /></i><span>TAC</span></a
        >
      </div> -->
    </div>

    <div class="col-3 section-images">
      <div class="img_div text-center">
        <img src="assets/home/manhore_lal.jpg" alt="" />
        <h1>Sh. Manohar Lal</h1>
        <p>Chief Minister<br />Haryana</p>
      </div>

      <div class="img_div text-center">
        <img src="assets/home/ds.png" alt="" />
        <h1>Sh. Devender Singh,</h1>
        <p>IAS Addl. Chief Secretary<br />Haryana</p>
      </div>
      <div class="img_div text-center">
        <img src="assets/activitiesImages/admin.jpeg" alt="" width="200px" height="200px" />
        <h1>Sh. Birender Singh <br />Engineer-In-Chief</h1>
        <p>Administrator <br />CADA Haryana</p>
      </div>

      <!-- <a href="#" class="blue yellow"
        ><i><img src="upload/M_1-9-2015-12-3-25.png" alt="" /></i
        ><span>Micro Irrigation</span></a
      >

      <a href="Page.aspx?PID=169&amp;LanguageType=1" class="blue org"
        ><i><img src="upload/M_1-9-2015-11-30-23.png" alt="" /></i
        ><span>Achievements</span></a
      > -->
    </div>
  </div>
  <div class="grid page-links">
    <div class="col-3 col-sm-4">
      <a href="https://cadaharyana.nic.in/Page.aspx?PID=175&LanguageType=1" class="blue"
        ><span>Tenders</span></a
      >
    </div>
    <div class="col-3 col-sm-4">
      <a href="https://cadaharyana.nic.in/Page.aspx?PID=176&LanguageType=1" class="blue par"
        ><span>Evaluation Study</span></a
      >
    </div>
    <div class="col-3 col-sm-4">
      <a href="https://cadaharyana.nic.in/Page.aspx?PID=177&LanguageType=1" class="blue yellow"
        ><span>Micro Irrigation</span></a
      >
    </div>
    <div class="col-3 col-sm-4">
      <a href="https://cadaharyana.nic.in/Page.aspx?PID=167&LanguageType=1" class="blue org"
        ><span>Projects</span></a
      >
    </div>
    <div class="col-3 col-sm-4">
      <a href="https://cadaharyana.nic.in/Page.aspx?PID=168&LanguageType=1" class="blue green"
        ><span>Annual Plan</span></a
      >
    </div>
    <div class="col-3 col-sm-4">
      <a href="https://cadaharyana.nic.in/Page.aspx?PID=169&LanguageType=1" class="blue org"
        ><span>Achievements</span></a
      >
    </div>
    <div class="col-3 col-sm-4">
      <a href="https://cadaharyana.nic.in/Page.aspx?PID=1183&LanguageType=1" class="blue gray"
        ><span>TAC</span></a
      >
    </div>
  </div>

  <div class="outer_gray">
    <div class="container-fluid">
      <div class="grid align-items-center">
        <div class="col-3 micada-logo">
          <img src="assets/home/footer_logo.png" alt="" />
        </div>
        <div class="col-6 micada-address">
          Bays 39-40, Sector 4, Panchkula<br />

          Fax No:0172-2562275<br />
          <div class="english">E-Mail:</div>
          <div class="hindi" style="display: none">ई-मेल:</div>
          <a href="hrcada@chd.nic.in"> hrcada@chd.nic.in</a>
        </div>
        <div class="col-3 micada-suggestion">
          <a
            href="ContactUs.aspx?LanguageType=1"
            id="suggestion"
            class="blue_btn"
            >Suggestions/Views</a
          >
        </div>
      </div>
    </div>
  </div>

  <footer>
    <div class="container-fluid">
      <div class="grid">
        <div class="col-12">
          <ul>
            <li>
              <a href="Page.aspx?PID=156" target="_blank"> Department</a>
            </li>

            <li>
              <a href="Page.aspx?PID=158" target="_blank"> Statistics </a>
            </li>

            <li>
              <a href="Page.aspx?PID=159" target="_blank"> Tenders/EOI</a>
            </li>

            <li>
              <a href="Page.aspx?PID=160" target="_blank"> Important Links</a>
            </li>

            <li>
              <a href="Page.aspx?PID=161" target="_blank"> Contact Us</a>
            </li>
          </ul>
          <p>
            Copyright © 2021 Micro Irrigation &amp; Command Area Development
            Authority, Haryana. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>

  <!-- <div id="highlights" class="py-4 px-4 lg:px-8 mx-0 my-6 lg:mx-8">


    <div class="grid mt-8 pb-2 md:pb-8">
      <div class="flex justify-content-center col-12 lg:col-6 p-0 flex-order-1 lg:flex-order-0"
        style="border-radius: 8px">
        <img src="assets/home/pic2.jpg" class="w-11" alt="mockup mobile" />
      </div>

      <div class="col-12 lg:col-6 my-auto flex flex-column lg:align-items-end text-center lg:text-right">
        <div class="flex align-items-center justify-content-center align-self-center lg:align-self-end"
          style="width: 4.2rem; height: 4.2rem; border-radius: 10px"></div>
        <h2 class="line-height-1 text-900 text-4xl font-normal">
          Upto 85% subsidy based Micro Irrigation Components
        </h2>
        <p class="text-100 p-2 pl-6 bg-blue-600 text-2xl left-border-radius">
          MI for Horticulture Crop
        </p>
        <p class="text-100 p-2 pl-6 bg-blue-600 text-2xl left-border-radius">
          MI for Agriculture Crop
        </p>
        <p class="text-100 p-2 pl-6 bg-blue-600 text-2xl left-border-radius">
          MI Components
        </p>
        <span class="text-700 text-2xl line-height-3 ml-0 md:ml-2" style="max-width: 650px">Command area development
          authority was setup in Haryana in year 1974
          under centrally sponsored scheme on sharing basis i.e. 50:50 by the
          State Government and Government of India to bridge the gap between the
          irrigation potential utilized through micro level infrastructure
          development and effective farm water management.</span>
      </div>
    </div>

    <div class="grid my-8 pt-2 md:pt-8">
      <div class="col-12 lg:col-6 my-auto flex flex-column text-center lg:text-left lg:align-items-start">
        <div class="flex align-items-center justify-content-center align-self-center lg:align-self-start"
          style="width: 4.2rem; height: 4.2rem; border-radius: 10px"></div>
        <h2 class="line-height-1 text-900 text-4xl font-normal">
          Micro Irrigation End to End Solution
        </h2>
        <span class="text-700 text-2xl line-height-3 mr-0 md:mr-2" style="max-width: 650px">One stop solution for
          implementation of micro irrigation related
          schemes</span>
      </div>

      <div class="flex justify-content-end flex-order-1 sm:flex-order-2 col-12 lg:col-6 p-0" style="border-radius: 8px">
        <img src="assets/home/images_micada.jpeg" class="w-11" alt="mockup" />
      </div>
    </div>
  </div> -->

  <!-- <div class="py-4 px-4 mx-0 mt-8 lg:mx-8">
    <div class="grid justify-content-between">
      <div class="col-12 md:col-2" style="margin-top: -1.5rem">
        <a
          class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3 cursor-pointer">
          <img src="assets/activitiesImages/micada_new_logo.png" alt="footer sections" width="100" height="100" class="mr-2" />
          <h5 class="font-small text-3xl text-900" style="font-size: 15px !important">
            Bays 39-40, Sector 4, Panchkula Fax No:0172-2562275 E-Mail:
            hrcada@chd.nic.in
          </h5>
        </a>
      </div>

      <div class="col-12 md:col-10 lg:col-7">
        <div class="grid text-center md:text-left">
          <div class="col-12 md:col-3">
            <h4 class="font-medium text-2xl line-height-3 mb-3 text-900">
              Department
            </h4>
          </div>

          <div class="col-12 md:col-3 mt-4 md:mt-0">
            <h4 class="font-medium text-2xl line-height-3 mb-3 text-900">
              Tenders / EOI
            </h4>
          </div>

          <div class="col-12 md:col-3 mt-4 md:mt-0">
            <h4 class="font-medium text-2xl line-height-3 mb-3 text-900">
              Contact US
            </h4>
          </div>

          <div class="col-12 md:col-3 mt-4 md:mt-0">
            <h4 class="font-medium text-2xl line-height-3 mb-3 text-900">
              Statistics
            </h4>
          </div>
          <div class="col-12 md:col-3 mt-4 md:mt-0">
            <h4 class="font-medium text-2xl line-height-3 mb-3 text-900">
              Important Links
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>
